import Input from './Input';

export type { InputProps, DefaultProps } from './Input';

export default Input;
